export default "__VITE_ASSET__cbeb503c__"